import React from 'react'

import { Dropdown, type DropdownOption } from '@/components/ui'
import { useApi } from '@/hooks'
import type { GeofenceCategory } from '@/types/dashboard-types'

import { toQueryParam } from '../common/queryUtils'

interface Params {
  companyIds?: number[]
  geofenceCategoryIds?: string[]
  onChange: (geofenceCategoryIds?: string[]) => void
}

export const GeofenceCategoryDropdown: React.FC<Params> = ({ geofenceCategoryIds, companyIds, onChange }) => {
  const { api } = useApi()
  const [options, setOptions] = React.useState<DropdownOption[]>([])
  const [placeholder, setPlaceholder] = React.useState('')

  React.useEffect(() => {
    if (!api) {
      return
    }
    if (!companyIds || companyIds.length === 0) {
      setOptions([])
      setPlaceholder('Choose a company to load geofence categories...')
      return
    }
    const fn = async () => {
      setPlaceholder('Loading...')
      const response = await api.get<GeofenceCategory[]>({
        path: `/fresh/geofence-categories?companyIds=${toQueryParam(companyIds)}&skip=0&take=10000&deleted=false&withDescendants=true`,
        origin: 'GeofenceDropdown',
      })
      if (response.error || !response.data) {
        console.error(response.error)
        setPlaceholder('Error loading geofence categories. Contact support.')
        setOptions([])
      } else {
        setPlaceholder('Choose one or more geofence categories...')
        setOptions(
          response.data.map((a) => {
            return {
              label: a.name,
              value: String(a.id),
            }
          })
        )
      }
    }
    fn()
  }, [companyIds])

  return (
    <div>
      <label>Geofence Category</label>
      <Dropdown
        options={options}
        handleMultiSelectItem={(opt: DropdownOption[]) => {
          const selectedValues = opt.filter((option) => option.value !== '').map((option) => option.value)
          const selectedGeofenceCategoryIds = selectedValues.length > 0 ? selectedValues : undefined
          onChange(selectedGeofenceCategoryIds)
        }}
        selectedItem={options.filter(
          (o) => Array.isArray(geofenceCategoryIds) && geofenceCategoryIds.includes(o.value)
        )}
        placeholder={placeholder}
        animateDots={/^Loading/.test(placeholder)}
        isMultiSelect
      />
    </div>
  )
}
